export default "__VITE_ASSET__DcSWpiPc__"